module.exports = __webpack_public_path__ + "Banner_LifehackLessons-5fc9bbd57c775ad5104b3e865d69fb25.svg";